import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {BaseMultiplyColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-multiply-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemMultiplyColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemMultiplyColor = useGetKeyFromEffectsActiveItem('multiplyColor');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || !activeItemMultiplyColor) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateMultiplyColor = (multiplyColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          multiplyColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseMultiplyColorPanel onUpdateMultiplyColor={updateMultiplyColor} multiplyColor={activeItemMultiplyColor} />;
}
